export const isNational = (user) =>
  ["national_admin", "developer"].includes(user?.role) || (user?.roles || []).includes("national_admin");
